var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h5',{staticClass:"mb-3"},[_vm._v(" "+_vm._s(_vm.$t(_vm.titleKey))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }